$('document').on('click', '.js-copy-clipboard', function(e) {
    /* Copy attribute data-clipboard to clipboard */
    e.preventDefault();

    const copyData = $(this).data('clipboard');
    navigator.clipboard.writeText(copyData);
});